import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

import { PointImpossiblePage } from '@fields/feature';

const searchSchema = z.object({
  ilotId: z.coerce.number().int().positive(),
  pointId: z.coerce.number().int().positive(),
  pointCode: z.string().optional(),
  sampleId: z.coerce.number().int().positive().optional(),
  lng: z.coerce.number().optional(),
  lat: z.coerce.number().optional(),
  zoom: z.coerce.number().optional(),
  scope: z.enum(['personal', 'organization']).optional(),
});

export const Route = createFileRoute('/_app/map-impossible')({
  validateSearch: zodSearchValidator(searchSchema),
  component: PointImpossiblePage,
});
